"use client";

import { useState } from "react";
import { LeadForm } from "@/components/ui/lead-form";

export function JewelryCollectionCTA() {
  const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);

  return (
    <>
      <div className="text-center mt-8">
        <p className="text-muted-foreground mb-4">
          Ready to transform your jewelry photography?
        </p>
        <div
          className="inline-flex items-center px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/70 transition-colors duration-200 font-medium cursor-pointer"
          onClick={() => setIsLeadFormOpen(true)}
        >
          Join Waitlist
        </div>
      </div>

      <LeadForm
        isOpen={isLeadFormOpen}
        onClose={() => setIsLeadFormOpen(false)}
        title="Join PhotoZoot Waitlist"
        buttonText="Submit & Join Waitlist"
      />
    </>
  );
}
